var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M15.8445 4.00897L16 4C16.6838 4 17.2473 4.51472 17.3244 5.17784L17.3333 5.33333V14.6667H26.6667C27.3504 14.6667 27.914 15.1814 27.991 15.8445L28 16C28 16.6838 27.4853 17.2473 26.8222 17.3244L26.6667 17.3333H17.3333V26.6667C17.3333 27.3504 16.8186 27.914 16.1555 27.991L16 28C15.3162 28 14.7527 27.4853 14.6756 26.8222L14.6667 26.6667V17.3333H5.33333C4.64955 17.3333 4.08599 16.8186 4.00897 16.1555L4 16C4 15.3162 4.51472 14.7527 5.17784 14.6756L5.33333 14.6667H14.6667V5.33333C14.6667 4.64955 15.1814 4.08599 15.8445 4.00897L16 4L15.8445 4.00897Z",
    fill: "#1D72E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFilled);
export default __webpack_public_path__ + "static/media/add_filled.421f2fa5e1a35420841583edba43ee0b.svg";
export { ForwardRef as ReactComponent };